module.exports = __webpack_public_path__ + "static/media/YingYingLi.c5f1039a.jpg";